import { render, staticRenderFns } from "./AdminVoucherEditor.vue?vue&type=template&id=5b18402d"
import script from "./AdminVoucherEditor.vue?vue&type=script&lang=js"
export * from "./AdminVoucherEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports